import { ImageGalleryBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpImageGalleryBlock } from './AmpImageGalleryBlock';
import { ImageGalleryBlock } from './ImageGalleryBlock';

export const ImageGalleryBlockMapping: BlockMapping<ImageGalleryBlockData> = {
  invariant: [
    {
      prop: 'images',
      msg: 'Images required for Image Gallery',
    },
  ],
  width: 'GRID',
  Component: ImageGalleryBlock,
  AmpComponent: AmpImageGalleryBlock,
};
